<template>
  <div class="container-register-kit">
    <div class="">
        <h5>Perfeito!
        Se você ainda não realizou a sua coleta, basta assistir o vídeo abaixo e realizá-la. <br></h5>
        <h6>Caso já tenha finalizado, clique no botão abaixo do vídeo para concluir esta etapa. </h6>
        <p>É rápido, seguro, e você já começa a ter mais saúde.</p>
      
      <div class="video-box">
        <!-- <iframe v-if="shipping_type == 1" width="100%" height="315" src="https://www.youtube.com/embed/tZCMFts3rec" title="Coleta Health ID Lab" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <iframe v-if="shipping_type == 2" width="100%" height="315" src="https://www.youtube.com/embed/X8l76_x7CGo" title="Coleta Health ID Lab" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <iframe v-if="shipping_type == 3" width="100%" height="315" src="https://www.youtube.com/embed/q6nQ6oy5beE" title="Coleta Health ID Lab" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
        <iframe width="100%" height="315" src="https://www.youtube.com/embed/xSqtTMzuhts" title="Coleta Health ID Lab" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="form-actions">
        <button class="button btn-primary" @click="$emit('next')">Prosseguir</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['next', 'shipping_type'],
    components: {},
    name: "KitOrientation",
    data: () => ({

    }),
    methods: {
      toView(n) {
        this.step = n;
            window.scrollTo(0, 0);
      },
    },
  }
</script>

<style scoped>
  .container-register-kit {
    max-width: 480px;
    margin: 0 auto;
  }
  .video-box {
    margin: 2rem 0;
  }
  .text h1 {
    font-size: 2.2rem;
  }

  h5.unweight {
    font-weight: normal;
  }

  .text p {
    color: #ee3a8f;
  }

  p.purple {
    color: #392474;
  }
  p.bold,
  span.bold {
    font-weight: bold;
  }

  span.orange {
    color: #EB8E1A;
    font-weight: bold;
  }

  .text p {
    margin-top: 12px;
  }

  .text img {
    width: 100%;
    margin-bottom: 2rem;
  }
  .flex-fields {
    display: flex;
    justify-content: space-between;
  }
  .flex-fields input,
  .flex-fields .input-box sm input[type="text"], .input-box sm .mx-datepicker{
    height: 41px;
    margin-top: 10px;
  }
  .flex-fields input[type="time"] {
    width: 30%;
  }
  .input-box sm .mx-datepicker{
    width: 65%;
  }
  @media screen and (max-width: 410px) {
    .flex-fields {
      flex-direction: column;
    }
  .flex-fields input[type="time"],
  .input-box sm .mx-datepicker{
    width: 100%;
  }
  }
	.form-actions {
		margin-top: 1.75rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/KitOrientation.vue